import { render, staticRenderFns } from "./wine-customer-sales.vue?vue&type=template&id=04cd4c02&scoped=true&"
import script from "./wine-customer-sales.vue?vue&type=script&lang=js&"
export * from "./wine-customer-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-customer-sales.vue?vue&type=style&index=0&id=04cd4c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd4c02",
  null
  
)

export default component.exports